import React, { Component } from "react";
import { Row, Col, Select } from "antd";
import TopParties from "./top-parties";
import { keepOnlyPTABQueryStrings } from "../../../../helpers/url";

const styles = {
  topParties: {
    textAlign: "center",
    margin: 16
  }
};
class CaseTabTopParties extends Component {
  state = {
    displaySize: 20
  };
  render() {
    const q = keepOnlyPTABQueryStrings(this.props.location.query);
    return (
      <div>
        <div>
          <Select
            value={this.state.displaySize}
            placeholder="Display Size"
            onChange={val => this.setState({ displaySize: val })}
            getPopupContainer={trigger => trigger.parentNode}
            style={{ width: 180, marginTop: 15, marginLeft: 15 }}
          >
            {[20, 50, 100].map(e => (
              <Select.Option value={e} key={e}>{`Show Top ${e}`}</Select.Option>
            ))}
          </Select>
        </div>
        <Row>
          <Col span={24} xl={12}>
            <TopParties type="p" query={q} style={styles.topParties} k={this.state.displaySize} />
          </Col>
          <Col span={24} xl={12}>
            <TopParties type="po" query={q} style={styles.topParties} k={this.state.displaySize} />
          </Col>
        </Row>
      </div>
    );
  }
}

export default CaseTabTopParties;
